import { TooltipInfoIcon } from "@vega-core/components/Tooltip/TooltipInfoIcon";
import { m } from "@vega-core/paraglide/messages";

export const CategoryDescriptionHelp = () => (
  <TooltipInfoIcon content={m.cases_settings_category_descriptionHelp()} />
);
